import {file} from 'paths.macro';
import store from "@/store";

export function authHeader() {
    let user = store.state.auth.user;
    // alert(user.token)
    if (user && user.token) {
        // if (process.env.NODE_ENV === "development") {
        //
        // }
        return { 'Authorization': 'Bearer ' + user.token };
    }
    else {
        return {};
    }
}

/**
 * Get JWT token from various sources (Pinia/Vuex stores or localStorage)
 * Used for Services API and other JWT-protected endpoints
 * @returns {string|null}
 */
export function getJWTToken() {
    // Try to get from Vuex store first (backward compatibility)
    try {
        const user = store.state.auth?.user;
        if (user?.token) {
            return user.token;
        }
    } catch (e) {
        // Store not available
    }

    // Try localStorage (Services API and other new endpoints)
    const token = localStorage.getItem('jwt_token') || localStorage.getItem('token');
    return token || null;
}

/**
 * Get JWT authorization headers for Services API
 * @returns {Object}
 */
export function getJWTHeaders() {
    const token = getJWTToken();
    if (!token) {
        throw new Error('No authentication token found. Please login first.');
    }

    return {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
    };
}